import React from "react";
import PropTypes from "prop-types";
import { FiAlertCircle } from "react-icons/fi";
import "./TargetHoursOverridesNotice.scss";

/**
 * Aviso compacto cuando hay overrides de horas objetivo fuera de la pestaña correspondiente.
 */
const TargetHoursOverridesNotice = ({
  children,
  actionLabel,
  onAction,
  className = "",
}) => (
  <div
    className={`target-hours-overrides-notice ${className}`.trim()}
    role="status"
  >
    <FiAlertCircle className="target-hours-overrides-notice__icon" aria-hidden />
    <div className="target-hours-overrides-notice__body">
      <div className="target-hours-overrides-notice__text">{children}</div>
      {actionLabel && onAction ? (
        <button
          type="button"
          className="target-hours-overrides-notice__action btn btn-link"
          onClick={onAction}
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  </div>
);

TargetHoursOverridesNotice.propTypes = {
  children: PropTypes.node.isRequired,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  className: PropTypes.string,
};

export default TargetHoursOverridesNotice;
